import script from "./ProductCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=67e8616d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e8616d"]])

export default __exports__